import { apiRoutesV2 } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  show(slug) {
    const url = apiRoutesV2.morphedPacks(slug);
    return FetchHelpers.get(url);
  },
};
